module.exports = __webpack_public_path__ + "static/media/iso.cd731654.JPG";